import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Sidebar from "../components/common/Sidebar";
import { getNewsEventBySlug, getMediaUrl } from "../services/catalogueService";
import "./NewsDetail.css";

export default function NewsDetail() {
  const { slug } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        setLoading(true);
        const data = await getNewsEventBySlug(slug);
        if (data) {
          setNewsItem(data);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching news detail:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchNewsDetail();
  }, [slug]);

  if (loading) {
    return (
      <>
        <Sidebar />
        <main className="content-area">
          <p style={{ color: "white", padding: "20px" }}>Loading details...</p>
        </main>
      </>
    );
  }

  if (error || !newsItem) {
    return <Navigate to="/news" replace />;
  }

  const attachmentPath = newsItem.attachmentUrl || newsItem.Attachment;
  const hasAttachment = Boolean(attachmentPath);
  const attachmentSrc = hasAttachment ? getMediaUrl(attachmentPath) : "";
  const isFullWidth = !newsItem.imageUrl && !hasAttachment;
  const itemTitle = newsItem.title || newsItem.Title;
  const itemDescription = newsItem.description || newsItem.Description;

  return (
    <>
      <Sidebar />
      <main className="content-area">
        <section className="news-detail-panel">
          <div className="news-detail-header-bar">
            <h2>{itemTitle}</h2>
          </div>

          <div className="news-detail-content-container">
            <div className="news-detail-top-section">
              {newsItem.imageUrl && (
                <div className="news-detail-image-box">
                  <img 
                    src={getMediaUrl(newsItem.imageUrl)} 
                    alt={itemTitle} 
                    className="news-detail-main-image"
                  />
                </div>
              )}

              <div className="news-detail-body">
                {itemDescription ? (
                  itemDescription.replace(/<[^>]*>?/gm, '').split('\n').map((para, i) => (
                    para.trim() ? <p key={i}>{para}</p> : null
                  ))
                ) : (
                  <p>No description available.</p>
                )}
              </div>
            </div>

            {hasAttachment && (
              <div className="news-attachment-block">
                <p style={{ color: '#ffffff', fontWeight: 'bold', marginBottom: '10px' }}>Attachment:</p>
                <a
                  className="news-pdf-icon-btn"
                  href={attachmentSrc}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img 
                    src="https://img.icons8.com/color/48/pdf.png" 
                    alt="PDF" 
                    style={{ width: '32px', height: '32px' }}
                  />
                </a>
              </div>
            )}

            <div className="news-footer-link">
              <Link className="read-more-news-btn" to="/news">
                Read More News
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
